var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74707 2.18194C6.74707 2.6763 7.1478 3.07704 7.64216 3.07704L11.9236 3.07704C11.9437 3.07704 11.9834 3.11512 11.9834 3.13965L11.9834 9.92451L10.1362 9.92451C9.86173 9.92451 9.67005 10.0943 9.67005 10.3374C9.67005 10.4305 9.69909 10.5243 9.75638 10.6162L12.4322 14.9136C12.5301 15.0709 12.6774 15.161 12.8363 15.161C12.9944 15.161 13.1408 15.0715 13.2381 14.9154L15.9138 10.6163C15.9711 10.5242 16.0002 10.4305 16.0002 10.3374C16.0002 10.0943 15.8085 9.92451 15.534 9.92451L13.7736 9.92451L13.7736 3.13965C13.7736 2.13535 12.9264 1.28685 11.9236 1.28685L7.64216 1.28685C7.1478 1.28685 6.74707 1.68758 6.74707 2.18194Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76213 1.08457L0.086421 5.38371C0.0290902 5.47577 -3.9968e-07 5.56953 -3.95613e-07 5.66258C-3.84987e-07 5.90569 0.191684 6.07548 0.466165 6.07548L2.22664 6.07548L2.22664 12.8603C2.22664 13.8646 3.07385 14.7131 4.07662 14.7131L8.35804 14.7131C8.8524 14.7131 9.25313 14.3124 9.25313 13.8181C9.25313 13.3237 8.8524 12.923 8.35804 12.923L4.07662 12.923C4.05653 12.923 4.01683 12.8849 4.01683 12.8603L4.01683 6.07548L5.86403 6.07548C6.13847 6.07548 6.33015 5.90569 6.33015 5.66258C6.33015 5.56953 6.30111 5.47573 6.24382 5.3838L3.56798 1.08641C3.47006 0.929137 3.32277 0.839002 3.16394 0.838957C3.00582 0.838957 2.85942 0.928465 2.76213 1.08457Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.0002,
    y1: 8.22394,
    x2: 6.74707,
    y2: 8.22394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.25313,
    y1: 7.77605,
    x2: -3.0323e-7,
    y2: 7.77605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.fee7a039ee3be83761156a2a2238b162.svg";
export { ForwardRef as ReactComponent };